import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useSmartRedirect } from '../../hooks/useSmartRedirect';
import { logger } from '../../utils/logger';
import { Loader } from '../ui/Loader';

/**
 * AppEntryPoint component handles the initial routing decision
 * when a user is authenticated. It determines whether to send
 * the user to the dashboard or to a specific project.
 */
export function AppEntryPoint() {
  const { getSmartRedirectPath } = useSmartRedirect();
  const [redirectPath, setRedirectPath] = React.useState<string | null>(null);

  useEffect(() => {
    logger.component('AppEntryPoint: Determining destination for authenticated user');

    getSmartRedirectPath()
      .then(path => {
        logger.component('AppEntryPoint: Redirect path determined', { path });
        setRedirectPath(path);
      })
      .catch(err => {
        logger.error('AppEntryPoint: Error determining redirect path', err);
        // Default to project page on error
        setRedirectPath('/project');
      });
  }, [getSmartRedirectPath]);

  // Show loading while checking dashboard relevance
  if (!redirectPath) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-900">
        <Loader />
      </div>
    );
  }

  // Redirect to the determined path
  return <Navigate to={redirectPath} replace />;
}
